import Layout from "./components/layout/Layout";

export default  function App() {
  return <Layout />;
}
